<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// updates
export default {
  name: "App",
  mounted() {
    $(window)
      .on("ready resize", function() {
        $(".vertical-layout").toggleClass(
          "menu-hide vertical-overlay-menu",
          $(window).width() < 768
        );
      })
      .trigger("resize");

    document.title = "Capital Bank ADMIN";
  }
};
</script>

<style>
body {
  font-family: "Avenir Next W1G Medium", -apple-system, BlinkMacSystemFont,
    "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue",
    sans-serif;
  background: white;
}

.font-regular {
  font-family: "Avenir Next W1G";
}

.font-medium {
  font-family: "Avenir Next W1G Medium";
}

.font-semibold {
  font-family: "Avenir Heavy";
}

.font-bold {
  font-family: "AvenirNextW15-Demi";
}

.font-weight-600 {
  font-weight: 600 !important;
}

.button {
  background-color: #32417e;
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
  display: inline-block;
  /* font-size: 15px; */
  font-size: 1rem;
  min-height: 36px;
  color: #fff;
  /* line-height: 36px; */
  line-height: 1.25;
  position: relative;
  text-decoration: none;
  /* padding: 0 1.2em; */
  padding: 0.75rem 1rem;
  transition-duration: 0.3s;
  font-family: "Avenir Next W1G Medium", -apple-system, BlinkMacSystemFont,
    "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue",
    sans-serif;
  font-weight: 400;
  text-transform: capitalize;
  transition-property: background-color, opacity, color, transform, box-shadow;
  transition-timing-function: ease-in-out;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  will-change: background-color, opacity, color, transform, box-shadow;
  box-shadow: 0 2px 4px 0 rgb(2 43 105 / 8%);
}

.button.button--outline,
button.button--outline {
  background-color: transparent;
  color: #32417e;
  border: 1px solid #32417e;
}

.button.disabled {
  background-color: #70a0d6 !important;
}

/* label */
label.bn-radio--label {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;

  /* margin: 12px 0; */

  cursor: pointer;
  position: relative;

  border: 1px solid #babfc7 !important;
  border-radius: 0.25rem;
  padding: 1rem;
  height: 3rem;
  margin: 0;
}

/* input */
input[type="radio"] {
  opacity: 0;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: -1;
}

/* .bn-radio--design */
.bn-radio--design {
  width: 16px;
  height: 16px;

  border: 1px solid #2b335e;
  border-radius: 100%;
  margin-right: 16px;

  position: relative;
}

.bn-radio--design::before,
.bn-radio--design::after {
  content: "";
  display: block;

  width: inherit;
  height: inherit;

  border-radius: inherit;

  position: absolute;
  transform: scale(0);
  transform-origin: center center;
}

.bn-radio--design:before {
  background: #32417e;
  opacity: 0;
  transition: 0.3s;
}

.bn-radio--design::after {
  background: #32417e;
  opacity: 0.4;
  transition: 0.6s;
}

/* .bn-radio--text */
.bn-radio--text {
  color: #2b335e;
  font-weight: 500;
}

/* checked state */
input[type="radio"]:checked + .bn-radio--design::before {
  opacity: 1;
  transform: scale(0.6);
  position: absolute;
  left: -1px;
  top: -1px;
}

/* other states */
input[type="radio"]:hover + .bn-radio--design,
input[type="radio"]:focus + .bn-radio--design {
  border: 1px solid #32417e;
}

input[type="radio"]:hover + .bn-radio--design:before,
input[type="radio"]:focus + .bn-radio--design:before {
  background: #32417e;
}

input[type="radio"]:hover ~ .bn-radio--text {
  color: #32417e;
}

input[type="radio"]:checked ~ .bn-radio--text {
  color: #32417e;
}

input[type="radio"]:focus + .bn-radio--design::after,
input[type="radio"]:active + .bn-radio--design::after {
  opacity: 0.1;
  transform: scale(2.6);
}

.actions-title {
  font-weight: 600;
  color: #32417e80 !important;
}

button.button[disabled] {
  opacity: 0.5;
  pointer-events: none;
}

.loader-center {
  display: flex;
  justify-content: center;
  align-items: center;
  top: 85px;
  left: 50%;
  transform: translate(-50%, -50%);
}

.arrow_text:hover {
  color: #32417e;
  transition: 0.3s;
}

.arrow_text {
  color: #d3d3d3;
  font-weight: 600;
  font-size: 15px;
}

/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default HTML checkbox */
.switch input.rounded-checkbox {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

/* let sweet alert be on all modals */
.swal2-container,
.swal-on-top {
  z-index: 200000 !important;
}
</style>
